import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function PageTakeover({ adUnitPath }) {
  const slotRef = useRef();

  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(() => {
      slotRef.current = window.googletag.defineOutOfPageSlot(adUnitPath, 'out-of-page-ad')
        .addService(window.googletag.pubads());
      window.googletag.enableServices();
      window.googletag.display('out-of-page-ad');
    });

    return () => {
      window.googletag.cmd.push(() => {
        window.googletag.destroySlots([slotRef.current]);
      });
    };
  }, [adUnitPath]);

  return (
    <div id="out-of-page-ad" />
  );
}

PageTakeover.propTypes = {
  adUnitPath: PropTypes.string.isRequired,
};

export default PageTakeover;
